const endpoints = {
	login: '/auth/login',
	resetPassRequest: '/auth/resetpassrequest',
	resetPass: '/auth/resetpass',
	checkToken: '/auth/checktoken',
	deleteAccountRequest: '/auth/deleteAccountRequest',
	cancelAccountDeletion: '/auth/cancelAccountDeletion',
	checkFirstTokenAndChangePassword: '/auth/checkFirstTokenAndChangePassword',
	setComplianceConsent: '/user/setComplianceConsent',
	rejectAllComplianceConsents: '/user/rejectAllComplianceConsents',
	createComplaint: '/denuncias',
	exportUserData: '/user/export',
	userInfo: '/user/details',
	usersList: '/user/list',
	setCapabilitiesByUserProject: '/user/setCapabilitiesByUserProject',
	getCapabilitiesByUserProject: '/user/getCapabilitiesByUserProject',
	setCapabilitiesByUserCompany: '/user/setCapabilitiesByUserCompany',
	getCapabilitiesByUserCompany: '/user/getCapabilitiesByUserCompany',
	removeUserFromProject: '/user/removeUserFromProject',
	setUserProjects: '/user/setUserProjects',
	getJobTypes: '/user/getJobTypes',
	createUser: '/user/create',
	addUserToProject: '/user/addUserToProject',
	updateUser: '/user/update',
	getUserByEmail: '/user/getUserByEmail',
	saveUserProjectOptions: '/user/setUserProjectOptions',
	createCompany: '/company/create',
	getCompaniesByUserID: '/company/getCompaniesByUserID',
	createProject: '/project/create',
	updateProject: '/project/update',
	getEntregaGraphs: '/entrega/getEntregaGraphs',
	exportEntregaGraphsPDF: '/entrega/exportEntregaGraphsPDF',
	getProjectTypes: '/project/getProjectTypes',
	getProjectByID: '/project/getProjectByID',
	searchUsersByEmail: '/project/searchUsersByEmail',
	getProjectsByUser: '/project/getProjectsByUser',
	getClosedProjectsByUser: '/project/getClosedProjectsByUser',
	getProjectsByUserID: '/project/getProjectsByUserID',
	getProjectSubjects: '/project/getProjectSubjects',
	updateProjectBoard: '/project/updateProjectBoard',
	closeProject: '/project/closeProject',
	setClosureConfig: '/project/setClosureConfig',
	setUserSpecialtySubscriptions: '/project/setUserSpecialtySubscriptions',
	getProjectSpecialties: '/project/getProjectSpecialties',
	setProjectConfig: '/project/setProjectConfig',
	getTasksWithApprovals: '/entrega/getTasksWithApprovals',
	setTaskApproval: '/entrega/setTaskApproval',
	bulkSetTaskApprovals: '/entrega/bulkSetTaskApprovals',
	getApprovalAttachment: '/entrega/getApprovalAttachment',
	getApprovalHistory: '/entrega/getApprovalHistory',
	editPlanoEntrega: '/entrega/editPlanoEntrega',
	deleteEntrega: '/entrega/deleteEntrega',
	openProject: '/project/openProject',
	createTask: '/tasks/create',
	listTasks: '/tasks/list',
	listTasksFilters: '/tasks/list/filters',
	saveTask: '/entrega/saveTask',
	enableAutocontrolTotal: '/entrega/enableAutocontrolTotal',
	supervisorApproval: '/entrega/supervisorApproval',
	closeEntrega: '/entrega/closeEntrega',
	markEntregaAsRead: '/entrega/markEntregaAsRead',
	changeVisualizationStatusEntrega: '/entrega/changeVisualizationStatus',
	verifyUserPassword: '/user/verify-password',
	nextCreatedTasks: '/tasks/nextMyCreatedTasks',
	nextPendingTasks: '/tasks/nextMyPendingTasks',
	nextEndedTasks: '/tasks/nextMyEndedTasks',
	listTasksByUser: '/tasks/listTasksByUser',
	updateTask: '/tasks/update',
	markTaskAsRead: '/tasks/markTaskAsRead',
	listMyTasks: '/tasks/listMyTasks',
	getTareaByID: '/tasks/getTareaByID',
	addInteraction: '/tasks/addInteraction',
	saveEntregaTask: '/entrega/saveTask',
	getPublicUrl: '/tasks/getPublicUrl',
	closeTask: '/tasks/closeTask',
	updateEntrega: '/entrega/update',
	approveSupervisor: '/entrega/approveSupervisor',
	deleteTask: '/tasks/deleteTask',
	sendTaskMail: '/tasks/sendTaskMail',
	addParticipant: '/tasks/addParticipant',
	removeParticipant: '/tasks/removeParticipant',
	downloadPDFTask: '/tasks/getTaskPDF',
	changeResponsable: '/tasks/changeResponsable',
	changeVisualizationStatus: '/tasks/changeVisualizationStatus',
	getTasksRestrictionsCodes: '/tasks/getTasksRestrictionsCodes',
	requestTaskAttribution: '/tasks/requestTaskAttribution',
	changeTaskAttributionRequest: '/tasks/changeTaskAttributionRequest',
	addChecklistItem: '/tasks/addChecklistItem',
	removeChecklistItem: '/tasks/removeChecklistItem',
	fileUpload: '/files/fileUpload',
	getProjectStorageSize: '/files/getProjectStorageSize',
	deleteFile: '/files/deleteFile',
	getZippedFiles: '/files/getZippedFiles',
	getZippedFilesByItem: '/files/getZippedFilesByItem',
	getFileAssociations: '/files/getFileAssociations',
	getDashboardInfo: '/dashboard/getDashboardInfo',
	getDashboard: '/dashboard/getDashboard',
	getDashboardWeekly: '/dashboard/getDashboard/weekly',
	getDashboardWeeklyExport: '/dashboard/getDashboard/weekly/export',
	getDashboardRDI: '/dashboard/getDashboardRDI',
	getDashboardRDIWeekly: '/dashboard/getDashboardRDI/weekly',
	getDashboardRDIWeeklyExport: '/dashboard/getDashboardRDI/weekly/export',
	createRdi: '/rdi/create',
	getAllRdisZip: '/rdi/getAllRdisZip',
	listRdi: '/rdi/list',
	listRdiFilters: '/rdi/list/filters',
	listEntrega: '/entrega/list',
	createEntrega: '/entrega/create',
	downloadEntregaPDF: '/entrega/getEntregaPDF',
	getEntregaByID: '/entrega/getEntrega',
	getPlanos: '/entrega/getPlanos',
	getProtocolos: '/entrega/getProtocolos',
	addPlano: '/entrega/addPlano',
	markForgeFileAsBlueprint: '/entrega/markForgeFileAsBlueprint',
	getPlano: '/entrega/getPlano',
	updatePlano: '/entrega/updatePlano',
	getAllProtocolos: '/entrega/getAllProtocolos',
	copyProtocolsToProject: '/entrega/copyProtocolsToProject',
	updateProtocolo: '/entrega/updateProtocolo',
	saveConfig: '/entrega/config',
	getConfig: '/entrega/getConfig',
	updateRdi: '/rdi/update',
	deleteRdi: '/rdi/deleteRdi',
	getRdiByID: '/rdi/getRdiByID',
	addRDIInteraction: '/rdi/addInteraction',
	addEntregaInteraction: '/entrega/addInteraction',
	closeRDI: '/rdi/closeRDI',
	markRdiAsRead: '/rdi/markRdiAsRead',
	downloadPDF: '/rdi/getRdiPDF',
	getRDIGraphs: '/rdi/getRDIGraphs',
	sendRDIMail: '/rdi/sendRDIMail',
	changeVisualizationStatusRdi: '/rdi/changeVisualizationStatus',
	setRdiSubscribers: '/rdi/setRdiSubscribers',
	removeRdiSubscriber: '/rdi/removeRdiSubscriber',
	exportStatusRdiByProject: '/exports/exportStatusRdiByProject',
	exportTasksByProject: '/exports/exportTasksByProject',
	projectUserExport: '/exports/projectUserExport',
	exportDocumentsListing: '/exports/exportDocumentsListing',
	deletePlano: '/entrega/deletePlano',
	addProtocolo: '/entrega/addProtocolo',
}
export {endpoints}
